import * as React from 'react';
import { FilePreviewImage } from '../FilePreviewImage/FilePreviewImage';
import { IFileFieldValue } from '../../../../types/file';
import * as styles from './styles.css';
import { Fullscreen16, Reload16, Trash16, useDeviceType } from '@cian/ui-kit';
import { useSortable } from '@dnd-kit/sortable';
import { FileFulscreenImage } from '../FileFulscreenImage';

export interface IFileViewProps {
  value: IFileFieldValue;
  id: number;
  onDelete(): void;
  onRotate(): void;
}

export const FileView: React.FC<IFileViewProps> = props => {
  const { id, value, onDelete, onRotate } = props;

  const isMobile = useDeviceType() === 'phone';

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id, disabled: isMobile });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0) scaleX(1) scaleY(1)` : 'none',
    transition,
  };

  const [openWindow, setOpenWindow] = React.useState(false);

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={styles['container']}
      data-testid="file-preview"
    >
      {openWindow && <FileFulscreenImage file={value} open={openWindow} onClose={() => setOpenWindow(false)} />}
      <div className={styles['preview']}>
        <FilePreviewImage file={value} />
      </div>
      <div className={styles['content']}>
        <div className={styles['description']}>
          <div className={styles['description-body']}>
            <div
              className={styles['fullscreen']}
              onClick={() => setOpenWindow(true)}
              data-testid="file-preview-fullscreen"
            >
              <Fullscreen16 color="white_100" display="inline-block" />
            </div>
            <div className={styles['rotate']} onClick={onRotate} data-testid="file-preview-rotate">
              <Reload16 color="white_100" display="inline-block" />
            </div>
            <div className={styles['delete']} onClick={onDelete} data-testid="file-preview-delete">
              <Trash16 color="white_100" display="inline-block" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
